import { render } from "./User-tablet.vue?vue&type=template&id=79fc2701&scoped=true"
import script from "./User-tablet.vue?vue&type=script&lang=js"
export * from "./User-tablet.vue?vue&type=script&lang=js"

import "./User-tablet.vue?vue&type=style&index=0&id=79fc2701&scoped=true&lang=scss"
import "./User-tablet.vue?vue&type=style&index=1&id=79fc2701&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79fc2701"]])

export default __exports__